import React, { PureComponent } from "react";
export class DeviceSmallIcon extends PureComponent {
  props: Object;
  render() {
    const { ...rest } = this.props;
    return (
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" {...rest}>
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Sensor-16x16" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="ic_wifi_tethering_24px" transform="translate(0.000000, 1.000000)" fill="#111111" fillRule="nonzero">
            <path
              d="M8,6.4 C7.12,6.4 6.4,7.12 6.4,8 C6.4,8.88 7.12,9.6 8,9.6 C8.88,9.6 9.6,8.88 9.6,8 C9.6,7.12 8.88,6.4 8,6.4 Z M12.8,8 C12.8,5.352 10.648,3.2 8,3.2 C5.352,3.2 3.2,5.352 3.2,8 C3.2,9.776 4.168,11.32 5.6,12.152 L6.4,10.76 C5.448,10.2 4.8,9.184 4.8,8 C4.8,6.232 6.232,4.8 8,4.8 C9.768,4.8 11.2,6.232 11.2,8 C11.2,9.184 10.552,10.2 9.6,10.76 L10.4,12.152 C11.832,11.32 12.8,9.776 12.8,8 Z M8,0 C3.584,0 0,3.584 0,8 C0,10.96 1.608,13.536 3.992,14.92 L4.792,13.536 C2.888,12.424 1.6,10.368 1.6,8 C1.6,4.464 4.464,1.6 8,1.6 C11.536,1.6 14.4,4.464 14.4,8 C14.4,10.368 13.112,12.424 11.2,13.536 L12,14.92 C14.392,13.536 16,10.96 16,8 C16,3.584 12.416,1.42108547e-15 8,0 Z"
              id="Shape"
            />
          </g>
        </g>
      </svg>
    );
  }
}
export default DeviceSmallIcon;



// WEBPACK FOOTER //
// ./src/_icons/DeviceSmallIcon/index.js